module.exports = __webpack_public_path__ + "assets/awaiting_confirmation.svg";